import common from './common';
import {spine} from '../libs/spine-threejs';

export default class ThreeSpine {
	constructor(spines) {
		this._skeletonData = {};
		this._spines = {};

		this.init(spines);
	}

	init(spines) {
		for (let i = 0; i < spines.length; i++) {
			let atlas = common.assets.spineCache.get(`/${spines[i]}.atlas`);
			let loader = new spine.AtlasAttachmentLoader(atlas);
			let json = new spine.SkeletonJson(loader);
			this._skeletonData[spines[i]] = json.readSkeletonData(common.assets.spineCache.get(`/${spines[i]}.json`));
			this._spines[spines[i]] = new spine.threejs.SkeletonMesh(this._skeletonData[spines[i]]);
		}
	}

	get(name) {
		return this._spines[name];
	}
}
